// src/components/mutation-observer/mutation-observer.styles.ts
import { css } from "lit";
var mutation_observer_styles_default = css`
  :host {
    display: contents;
  }
`;

export {
  mutation_observer_styles_default
};
